import styled from 'styled-components';

export const NewActivity = styled.div`
  background: white;
  min-height: 100%;
`
